const AdminUsers = ['marian@hashrocket.com', 'diana@hashrocket.com'];

export const CanDrop = user => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  return AdminUsers.includes(user.email);
};



// WEBPACK FOOTER //
// ./src/utils/permissions.js